<script lang="ts" setup>
import { SancareSticky } from '@sancare/typescript-commons'
import { computed } from 'vue'

import AdminStayHeader from '@/stay-displayer/common/AdminStayHeader.vue'
import PatientCard from '@/stay-displayer/common/PatientCard.vue'
import WeekDaysPresence from '@/stay-displayer/smr/rhs/WeekDaysPresence.vue'
import SmrRhsCard from '@/stay-displayer/smr/SmrRhsCard.vue'
import SmrStayCard from '@/stay-displayer/smr/SmrStayCard.vue'
import { useStore } from '@/store'
import { PmsiTypeEnum } from '@/store/modules/settings/types'
import { Rhs, SmrStay } from '@/store/modules/stay/smr/types'

const store = useStore()

const props = defineProps<{
  stay: SmrStay
  displayedRhs?: Rhs | null
}>()

const pseudonymizationEnabled = computed(() => store.getters.flatSancareSettings['enable_pseudonymization'])
const fullName = computed(() => store.getters['smrStay/fullName'])

const currentIndexRhs = computed(() => {
  if (!props.displayedRhs || !props.stay.rhsList) return undefined
  return props.stay.rhsList.findIndex((rhs) => rhs.id === props.displayedRhs?.id)
})

const totalRhs = computed(() => props.stay.rhsList?.length ?? 0)

</script>

<template>
  <sancare-sticky class="patient-data-container">
    <div class="general-stay-data card">
      <div class="card-body">
        <div class="data-table">
          <div class="mb-3">
            <admin-stay-header
              :administrative-local-stay-id="String(stay.administrativeLocalStayId)"
              :pmsi-id="String(stay.smrId)"
              :pmsi-type="PmsiTypeEnum.SMR"
              :stay-id="stay.id"
              :rhs-id="displayedRhs?.id ?? null"
            >
              <div
                v-if="displayedRhs"
                class="calendar-boxes"
              >
                <week-days-presence
                  :rhs="displayedRhs"
                  mode="labeled"
                />
              </div>
            </admin-stay-header>
          </div>

          <div class="row g-4">
            <div class="col">
              <patient-card
                :patient="stay.patient"
                :patient-age="stay.patientAge"
                :full-name="fullName"
                :pseudonymization-enabled="pseudonymizationEnabled"
              />
            </div>

            <div class="col">
              <smr-stay-card
                :stay="stay"
                :displayed-rhs="displayedRhs"
                :rhs-index="currentIndexRhs"
              />
            </div>

            <div
              v-if="displayedRhs"
              class="col"
            >
              <smr-rhs-card
                :rhs="displayedRhs"
                :rhs-index="currentIndexRhs"
                :total-rhs="totalRhs"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </sancare-sticky>
</template>

<style lang="scss" scoped>
.calendar-boxes {
  display: flex;
  gap: 2px;
}
</style>
